import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Loading from "../Loading";
import { useDispatch } from "react-redux";
import {
  showSubscribeBox,
  setSelectedInmate,
  showUnregisterBox,
} from "../coe/coeSlice";
import {
  PlusSmIcon,
  MinusSmIcon,
  ChevronLeftIcon,
  ChevronDoubleLeftIcon,
  ChevronRightIcon,
  ChevronDoubleRightIcon,
  PlusCircleIcon,
  TrashIcon,
} from "@heroicons/react/solid";

// import {insert} from './inmatesSlice';
// import {
//   PlusCircleIcon,
//   TrashIcon,
//   ArrowCircleLeftIcon,
//   ArrowCircleRightIcon
// } from "@heroicons/react/solid";

// function InmateList() {
//   const [currShown, setCurrShown] = useState(6);
//   const [i, setI] = useState(0);
//   const [shown, setShown] = useState([]);
//   const [page, setPage] = useState(1);
//   const inmates = useSelector(state => state.inmates.inmates);
//   const dispatch = useDispatch();
//   useEffect(() => {
//     fillShown(6, 0);
//   }, [inmates]);

//   const handleRight = async () => {
//     if (inmates.length <= currShown) {
//       return;
//     }

//     setCurrShown(currShown => currShown + 6);
//     setI(i => i + 6);
//     setPage(page => page + 1);

//     await setShown([]);
//     fillShown(currShown + 6, i + 6);
//   };
//   async function handleLeft() {
//     if (0 == i) {
//       return;
//     }
//     setCurrShown(currShown - 6);
//     setI(i - 6);
//     setPage(page - 1);
//     await setShown([]);
//     fillShown(currShown - 6, i - 6);
//   }

//   function fillShown(curr, i) {
//     let tempShown = [];
//     for (var index = i; index < curr; index++) {
//       if (inmates.length <= index) {
//         tempShown.push({
//           name: "_",
//           id: index,
//           sex: "",
//           race: "",
//           height: "",
//           weight: "",
//           age: ""
//         });
//       } else {
//         tempShown.push(inmates[index]);
//       }
//     }
//     setShown(tempShown);
//   }
//   return (
//     <div className="w-full" style={{visibility: inmates.length===0 ? "hidden" : "visible"}}>
//       <div className="md:inline-flex hidden w-full h-auto bg-blue-200 p-4 rounded-lg ">
//         <ArrowCircleLeftIcon
//           className={
//             page === 1
//               ? "h-14 m-auto fill-current text-blue-200"
//               : "h-14 m-auto cursor-pointer"
//           }
//           onClick={handleLeft}
//         />
//         <ul className="grid grid-cols-1 w-full transition gap-6 ml-2 mr-2 sm:grid-cols-2 lg:grid-cols-3">
//           {shown.map(shown => (
//             <li
//               key={shown.id}
//               className="col-span-1 w-full transition bg-white rounded-lg shadow divide-y divide-gray-200"
//               style={{
//                 visibility: shown.name === "_" ? "hidden" : "visible"
//               }}
//             >
//               <div className=" flex items-center justify-between p-5 space-x-6">
//                 <div className="flex-1 truncate">
//                   <div className="flex items-center space-x-3">
//                     <h3 className="text-gray-900 text-sm font-medium truncate">
//                       {shown.name}
//                     </h3>
//                   </div>
//                   <span className="flex-shrink-0 inline-block px-2 py-0.5 text-green-800 text-xs font-medium bg-blue-100 rounded-full">
//                     {shown.id}
//                   </span>

//                   <p className="mt-1 text-gray-500 text-sm truncate">
//                     {shown.sex} | {shown.race} | {shown.age} | {shown.height}
//                   </p>
//                   <p className="mt-1 text-gray-500 text-sm truncate">
//                     {shown.weight} lbs
//                   </p>
//                 </div>
//               </div>
//               <div>
//                 <div className="-mt-px flex divide-x divide-gray-200">
//                   <div className="w-0 flex-1 flex">
//                     <a
//                       // href={`mailto:${shown.name}`}
//                       className="relative -mr-px w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-700 font-medium border border-transparent rounded-bl-lg hover:text-gray-500"
//                     >
//                       <PlusCircleIcon
//                         className="w-5 h-5 text-gray-400"
//                         aria-hidden="true"
//                       />
//                       <span className="ml-3">
//                         COE
//                         <br /> Register
//                       </span>
//                     </a>
//                   </div>
//                   <div className="-ml-px w-0 flex-1 flex">
//                     <a
//                       // href={`tel:${shown.name}`}
//                       className="relative w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-700 font-medium border border-transparent rounded-br-lg hover:text-gray-500"
//                     >
//                       <TrashIcon
//                         className="w-5 h-5 ml-2 text-gray-400"
//                         aria-hidden="true"
//                       />
//                       <span className="ml-3"> COE UnRegister</span>
//                     </a>
//                   </div>
//                 </div>
//               </div>
//             </li>
//           ))}
//         </ul>
//         <ArrowCircleRightIcon
//           className={
//             page === Math.ceil(inmates.length / 6) || inmates.length === 0
//               ? "h-14 m-auto fill-current text-blue-200"
//               : "h-14 m-auto cursor-pointer"
//           }
//           onClick={handleRight}
//         />
//       </div>
//       <div className="text-center md:block hidden" >
//         Page {}
//         <div className="inline-flex ">{page}</div>
//         <div className="inline-flex ">
//           <p>&nbsp;</p>of {Math.ceil(inmates.length / 6)}
//         </div>
//       </div>

//       {
//         //////////////////////////////////////////////////////////////////////////////////
//       }

//       <div className="inline-flex w-full h-auto bg-blue-200 rounded-lg md:hidden p-5">
//         <ul className="grid grid-cols-1 w-full transition gap-6 ">
//           {inmates.map(inmate => (
//             <li
//               key={inmate.id}
//               className="col-span-1 w-full transition bg-white rounded-lg shadow divide-y divide-gray-200"
//               style={{
//                 visibility: inmate.name === "_" ? "hidden" : "visible"
//               }}
//             >
//               <div className=" flex items-center justify-between p-5 space-x-6">
//                 <div className="flex-1 truncate">
//                   <div className="flex items-center space-x-3">
//                     <h3 className="text-gray-900 text-sm font-medium truncate">
//                       {inmate.name}
//                     </h3>
//                   </div>
//                   <span className="flex-shrink-0 inline-block px-2 py-0.5 text-green-800 text-xs font-medium bg-blue-100 rounded-full">
//                     {inmate.id}
//                   </span>

//                   <p className="mt-1 text-gray-500 text-sm truncate">
//                     {inmate.sex} | {inmate.race} | {inmate.age} |{" "}
//                     {inmate.height}
//                   </p>
//                   <p className="mt-1 text-gray-500 text-sm truncate">
//                     {inmate.weight} lbs
//                   </p>
//                 </div>
//               </div>
//               <div>
//                 <div className="-mt-px flex divide-x divide-gray-200">
//                   <div className="w-0 flex-1 flex">
//                     <a
//                       // href={`mailto:${shown.name}`}
//                       className="relative -mr-px w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-700 font-medium border border-transparent rounded-bl-lg hover:text-gray-500"
//                     >
//                       <PlusCircleIcon
//                         className="w-5 h-5 text-gray-400"
//                         aria-hidden="true"
//                       />
//                       <span className="ml-3">
//                         COE
//                         <br /> Register
//                       </span>
//                     </a>
//                   </div>
//                   <div className="-ml-px w-0 flex-1 flex">
//                     <a
//                       // href={`tel:${shown.name}`}
//                       className="relative w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-700 font-medium border border-transparent rounded-br-lg hover:text-gray-500"
//                     >
//                       <TrashIcon
//                         className="w-5 h-5 ml-2 text-gray-400"
//                         aria-hidden="true"
//                       />
//                       <span className="ml-3"> COE UnRegister</span>
//                     </a>
//                   </div>
//                 </div>
//               </div>
//             </li>
//           ))}
//         </ul>
//       </div>
//     </div>
//   );
// }

function InmateList() {
  // Selects inmates from redux store
  const inmates = useSelector((state) => state.inmates.inmates);

  const loading = useSelector((state) => state.inmates.loading);

  const error01 = useSelector((state) => state.inmates.error01);
  const error02 = useSelector((state) => state.inmates.error02);
  const warning01 = useSelector((state) => state.inmates.warning01);
  const failed = useSelector((state) => state.inmates.failed);
  const error03 = useSelector((state) => state.inmates.error03);
  // Sets end index of inmates array to be shown on current page
  const [endShown, setEndShown] = useState(10);
  const [cardEndShown, setCardEndShown] = useState(10);
  // Sets start index of inmates array to be shown on current page
  const [startShown, setStartShown] = useState(0);
  // Holds inmates that are currently being shown on the page
  const [shown, setShown] = useState([]);
  const [page, setPage] = useState(1);

  const dispatch = useDispatch();

  useEffect(() => {
    setStartShown(0);
    setEndShown(10);
    setCardEndShown(10);
    setPage(1);
    fillShown(0, 10);
  }, [inmates]);

  // Large list view functions
  // Fills array of inmates to show on screen by giving start and end index
  function fillShown(start, end) {
    let arr = [];
    for (let i = start; i < end; i++) {
      if (i < inmates.length) {
        arr.push(inmates[i]);
      } else {
        arr.push({ fname: "_" });
      }
    }
    setShown(
      arr.map((inmate) => (
        <tr
          className="hover:bg-orange-light cursor-pointer "
          style={{ display: inmate.fname === "_" ? "none" : "" }}
          key={inmate.scdcId}
        >
          <td
            className="px-6 py-4 whitespace-nowrap "
            onClick={() => {
              window.open(
                "https://public.doc.state.sc.us/scdc-public/inmateDetails.do?id=" +
                  inmate.scdcIdType +
                  inmate.scdcId
              );
            }}
          >
            <div className="flex items-center">
              <div className="flex-shrink-0 h-10 w-10">
                <img
                  className="h-10 w-10 rounded-full"
                  src={`data:image/png;base64,${inmate.thumbnail}`}
                  alt=""
                ></img>
              </div>
              <div className="ml-4 w-36">
                <div className="text-sm font-medium text-gray-900 truncate">
                  {inmate.lname}, {inmate.fname}
                  {inmate.mname}
                </div>
                <div className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-blue-100 text-blue-900">
                  {inmate.scdcId}
                </div>
              </div>
            </div>
          </td>
          <td
            className="px-2 py-4 whitespace-nowrap truncate"
            onClick={() => {
              window.open(
                "https://public.doc.state.sc.us/scdc-public/inmateDetails.do?id=" +
                  inmate.scdcIdType +
                  inmate.scdcId
              );
            }}
          >
            <div className="text-sm text-gray-900 text-center">
              {inmate.sex}
            </div>
          </td>
          <td
            className="px-2 py-4 whitespace-nowrap "
            onClick={() => {
              window.open(
                "https://public.doc.state.sc.us/scdc-public/inmateDetails.do?id=" +
                  inmate.scdcIdType +
                  inmate.scdcId
              );
            }}
          >
            <div className="text-sm text-gray-900 text-center ">
              {inmate.race}
            </div>
          </td>
          <td
            className="px-2 py-4 whitespace-nowrap text-sm text-gray-500 text-center"
            onClick={() => {
              window.open(
                "https://public.doc.state.sc.us/scdc-public/inmateDetails.do?id=" +
                  inmate.scdcIdType +
                  inmate.scdcId
              );
            }}
          >
            {inmate.height ? inmate.height.slice(0, 1) : ""}'{" "}
            {inmate.height ? inmate.height.slice(1, 3) : ""}"
          </td>
          <td
            className="px-2 py-4  whitespace-nowrap text-sm text-gray-500 text-center "
            onClick={() => {
              window.open(
                "https://public.doc.state.sc.us/scdc-public/inmateDetails.do?id=" +
                  inmate.scdcIdType +
                  inmate.scdcId
              );
            }}
          >
            {inmate.weight}
          </td>
          <td
            className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-center"
            onClick={() => {
              window.open(
                "https://public.doc.state.sc.us/scdc-public/inmateDetails.do?id=" +
                  inmate.scdcIdType +
                  inmate.scdcId
              );
            }}
          >
            {inmate.age}
          </td>
          <td
            className="px-6 py-4 whitespace-nowrap  text-sm font-medium"
            onClick={() => inmateSubscribe(inmate)}
          >
            <a href="#" className="text-blue-primary  hover:text-blue-200">
              <PlusSmIcon className="h-8 m-auto " />
            </a>
          </td>
          <td
            onClick={() => inmateUnregister(inmate)}
            className="px-6 py-4 whitespace-nowrap text-center text-sm font-medium"
          >
            <a href="#" className="text-blue-primary hover:text-blue-200">
              <TrashIcon className="h-6 m-auto" />
            </a>
          </td>
        </tr>
      ))
    );
  }

  function handleRight() {
    if (inmates.length <= endShown) {
      return;
    }

    setStartShown(startShown + 10);
    setEndShown(endShown + 10);
    setPage(page + 1);

    fillShown(startShown + 10, endShown + 10);
  }
  function handleLeft() {
    if (startShown == 0) {
      return;
    }

    setStartShown(startShown - 10);
    setEndShown(endShown - 10);
    setPage(page - 1);

    fillShown(startShown - 10, endShown - 10);
  }

  function goToFirstPage() {
    setStartShown(0);
    setEndShown(10);
    setPage(1);
    fillShown(0, 10);
  }
  function goToLastPage() {
    var last;
    if (inmates.length % 10 == 0) {
      last = 10 * Math.floor(inmates.length / 10);
    } else {
      last = 10 + 10 * Math.floor(inmates.length / 10);
    }
    console.log(last);
    setStartShown(last - 10);
    setEndShown(last);
    setPage(last / 10);
    fillShown(last - 10, last);
  }

  //Card view functions (phone view)
  function loadMore() {
    setCardEndShown(cardEndShown + 10);
  }

  function backToTop(e) {
    e.preventDefault();
    document.querySelector('[id="top-of-list"]').scrollIntoView();
  }

  // COE Functions ////////////////////////////////
  function inmateSubscribe(inmate) {
    console.log("123");
    dispatch(showSubscribeBox());
    dispatch(setSelectedInmate(inmate));
  }
  function inmateUnregister(inmate) {
    dispatch(showUnregisterBox());
    dispatch(setSelectedInmate(inmate));
  }
  /////////////////////////////////////////////////
  return (
    <div>
      {/* <div classNameName="ml-56" style={{ display: loading ? "" : "none" }}>
        <Loading
          type={"spinningBubbles"}
          color={"black"}
          style={{ display: "none" }}
        />
      </div> */}
      <div>
        <div
          className="md:flex flex-col hidden"
          style={{ display: inmates.length === 0 ? "none" : "" }}
        >
          <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
              <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th
                        scope="col"
                        className="px-6 py-3  text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        Name
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        Sex
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        Race
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        Height
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        Weight
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        Age
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        COE Register
                      </th>
                      <th
                        scope="col"
                        className=" py-3 pr-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        COE Unregister
                      </th>
                      {/* <th scope="col" className="relative px-6 py-3">
                        <span className="sr-only">Edit</span>
                      </th> */}
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {shown}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="inline-flex p-2 m-auto">
            <ChevronDoubleLeftIcon
              onClick={goToFirstPage}
              className="h-8 mr-2 cursor-pointer"
              style={{ visibility: page === 1 ? "hidden" : "visible" }}
            />
            <ChevronLeftIcon
              onClick={handleLeft}
              className="h-8 mr-2 cursor-pointer"
              style={{ visibility: page === 1 ? "hidden" : "visible" }}
            />
            <div className="select-none">
              Page {page} of {Math.ceil(inmates.length / 10)}
            </div>
            <ChevronRightIcon
              onClick={handleRight}
              className="h-8 ml-2 cursor-pointer"
              style={{
                visibility: page * 10 >= inmates.length ? "hidden" : "visible",
              }}
            />
            <ChevronDoubleRightIcon
              onClick={goToLastPage}
              className="h-8 ml-0 cursor-pointer"
              style={{
                visibility: page * 10 >= inmates.length ? "hidden" : "visible",
              }}
            />
          </div>
        </div>
        {/* Start of phone view list */}
        <div
          className="w-full h-auto md:hidden pb-2"
          style={{ visibility: inmates.length === 0 ? "hidden" : "visible" }}
        >
          <div className="text-xl text-center pb-4 pt-2" id="top-of-list">
            Results
          </div>
          <ul className="grid grid-cols-1 sm:grid-cols-2 w-full transition gap-6 ">
            {inmates.slice(0, cardEndShown).map((inmate) => (
              <li
                key={inmate.scdcId}
                className="col-span-1 w-full transition bg-gray-100 rounded-lg shadow-md divide-y divide-gray-300 cursor-pointer"
                style={{
                  visibility: inmate.fname === "_" ? "hidden" : "visible",
                }}
              >
                <div
                  className=" flex items-center justify-between p-5 space-x-2"
                  onClick={() => {
                    window.open(
                      "https://public.doc.state.sc.us/scdc-public/inmateDetails.do?id=" +
                        inmate.scdcIdType +
                        inmate.scdcId
                    );
                  }}
                >
                  <img
                    className="h-10 w-10 rounded-full"
                    src={`data:image/png;base64,${inmate.thumbnail}`}
                    alt=""
                  ></img>
                  <div className="flex-1 truncate">
                    <div className="flex items-center space-x-3">
                      <h3 className="text-gray-900 text-md font-medium truncate">
                        {inmate.lname}, {inmate.fname}
                        {inmate.mname}
                      </h3>
                      <span className="flex-shrink-0 inline-block px-2 py-0.5 text-blue-900 text-xs font-medium bg-blue-100 rounded-full">
                        {inmate.scdcId}
                      </span>
                    </div>

                    <div className="mt-1 text-gray-500 text-sm truncate">
                      {inmate.sex} | {inmate.race} | {inmate.age} yrs |{" "}
                      {inmate.height ? inmate.height.slice(0, 1) : ""}'{" "}
                      {inmate.height ? inmate.height.slice(1, 3) : ""}" |{" "}
                      {inmate.weight} lbs
                    </div>
                    <p className="mt-1 text-gray-500 text-sm truncate"></p>
                  </div>
                </div>
                <div>
                  <div className="-mt-px flex divide-x divide-gray-200">
                    <div className="w-0 flex-1 flex">
                      <div
                        onClick={() => inmateSubscribe(inmate)}
                        className="relative -mr-px w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-700 font-medium border border-transparent rounded-bl-lg hover:text-gray-500"
                      >
                        <PlusCircleIcon
                          className="w-5 h-5 text-gray-400"
                          aria-hidden="true"
                        />
                        <span className="ml-3">
                          COE
                          <br /> Register
                        </span>
                      </div>
                    </div>
                    <div className="-ml-px w-0 flex-1 flex">
                      <div
                        onClick={() => inmateUnregister(inmate)}
                        className="relative w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-700 font-medium border border-transparent rounded-br-lg hover:text-gray-500"
                      >
                        <TrashIcon
                          className="w-5 h-5 ml-2 text-gray-400"
                          aria-hidden="true"
                        />
                        <span className="ml-3"> COE UnRegister</span>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
          <div
            className=" block text-center p-2 pt-4"
            onClick={loadMore}
            style={{ display: inmates.length <= cardEndShown ? "none" : "" }}
          >
            Load More
          </div>
          <div className="text-center pt-2">
            <a href={""} onClick={(e) => backToTop(e)}>
              Back to top
            </a>
          </div>
        </div>
        {/* End phone view list */}
        <div
          className="text-red-500 text-lg pb-2 "
          style={{ display: error01 ? "block" : "none" }}
        >
          <span className="underline">ERROR:</span> To request a search, please
          enter either an SCDC ID, First and/or Last name or an SID.
        </div>

        <div
          className="text-red-500 text-lg pb-2 "
          style={{ display: error02 ? "block" : "none" }}
        >
          <span className="underline">ERROR:</span> To request a search, please
          make a selection from the dropdowns provided or select a release date.
        </div>
        <div
          className="text-red-500 text-lg pb-2 "
          style={{ display: error03 ? "block" : "none" }}
        >
          <span className="underline">ERROR:</span> To request a search with a
          release date range, please select a start date and an end date.
        </div>
        <div
          className="text-red-500 text-lg pb-2 "
          style={{ display: warning01 ? "block" : "none" }}
        >
          <span className="underline">WARNING:</span> Your search returned more
          inmates than can be displayed. Search results are limited to 250
          inmates. Please enter more restrictive search criteria and submit your
          search again.
        </div>
        <div
          className="text-red-500 text-lg pb-2 "
          style={{ display: failed ? "block" : "none" }}
        >
          Your search failed to return any results. Please review your search
          criteria and try again.
        </div>
      </div>
    </div>
  );
}

export default InmateList;
